export default __webpack_public_path__ + "static/media/logo.fa079316.png";